module.exports = __webpack_public_path__ + "img/3.3101a406.jpg";